/**
 * Calculates the total protein content of a product based on its ingredients.
 */
export function calculateTotalProtein(product: Product): number | null {
  const { ingredients } = product;
  const hasOnlyInvalidValues = ingredients.every(checkIfHasInvalidValues);

  if (hasOnlyInvalidValues) {
    return null;
  }

  const totalProtein = [...ingredients].reduce(addProtein, 0);

  return Math.round(totalProtein);
}

// ─────────────────────────────────────────────────────────────────────────────

function checkIfHasInvalidValues(ingredient: Ingredient) {
  return typeof ingredient.proteinG !== 'number';
}

function addProtein(total: number, ingredient: Ingredient) {
  const protein =
    typeof ingredient.proteinG === 'number' ? ingredient.proteinG : 0;

  return total + protein;
}

// ─── Types ───────────────────────────────────────────────────────────────────

type Product = {
  ingredients: Ingredient[] | readonly Ingredient[];
};

type Ingredient = { proteinG: number | null };
